import React from 'react';

import { Box } from '@mui/material';

interface ContentLayoutProps {
  children: React.ReactNode;
}

export default function ContentLayout({ children }: ContentLayoutProps) {
  return (
    <Box
      sx={{
        width: 'inherit',
        padding: 2,
      }}
    >
      {children}
    </Box>
  );
}
